// Shop functionality
// Guard: only run if shop page elements exist
if (!document.getElementById('buyLuckPotion')) {
	// Not on shop page, skip this module
} else {

// Wait for DOM to be ready and globals to be availablec
document.addEventListener('DOMContentLoaded', () => {
	// Double-check we're on the shop page after DOM loads
	if (!document.getElementById('buyLuckPotion')) return;
	
// STORAGE_KEY is now defined in index.js
const POTION_BASE_COST = 100000;
const POTION_DURATION = 5 * 60 * 1000; // 5 minutes in ms
const BENNY_COST = 10000;
const BENNY_DURATION = 5 * 60 * 1000; // 5 minutes
const BLESSING_COST = 8000;
const BLESSING_DURATION = 5 * 60 * 1000; // 5 minutes
const SLOT_MACHINE_COST = 1000000;
const SLOT_MACHINE_BONUS = 5;

// DOM elements (coinsEl and luckMultiplierEl are defined in index.js)
const buyBtn = document.getElementById('buyLuckPotion');
const timerEl = document.getElementById('potionTimer');
const buyBennyBtn = document.getElementById('buyBennyBoost');
const bennyTimerEl = document.getElementById('bennyTimer');
const buyBlessingBtn = document.getElementById('buyPumpkinBlessing');
const blessingTimerEl = document.getElementById('blessingTimer');
const buySlotMachineBtn = document.getElementById('buySlotMachine');
const slotsPurchasedEl = document.getElementById('slotsPurchased');
const buyThanksgivingPotion = document.getElementById('buyThanksgivingPotion');
const claimBTFPlusBtn = document.getElementById('claimBTFPlus');
const claimPopUp = document.querySelector('.claim-popup');
const closeClaimPopUpBtn = document.getElementById('close-claim-popup');
const claimOrderBtn = document.getElementById('claim-order-btn');
const orderNumberInput = document.getElementById('order-number');
// Brewing UI
const tearsDisplayEl = document.getElementById('tearsDisplay');
const brewFruitListEl = document.getElementById('brewFruitList');
const brewSelectionEl = document.getElementById('brewSelection');
const brewPreviewEl = document.getElementById('brewPreview');
const brewPotionBtn = document.getElementById('brewPotionBtn');

// Ensure we have local references to common header elements (may not rely on globals)
const coinsEl = document.getElementById('coins');
const luckMultiplierEl = document.getElementById('luckMultiplier');

// Shared luck tuning
const luckStackBonus = window.LUCK_STACK_BONUS || 1.2;
const formatLuck = window.formatLuckMultiplier || ((val)=> Number.isInteger(val) ? val : Number(val.toFixed(1)));

// State is now defined in index.js - use the global state
// Local state object removed to avoid duplicate declaration



// Load state
function loadState() {
    try {
        const STORAGE_KEY = 'btf_state_v1'; // Use local constant for shop page
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if(!window.state) window.state = {};
            window.state.coins = parsed.coins ?? 0;
            window.state.potionActive = parsed.potionActive ?? false;
            window.state.potionEndsAt = parsed.potionEndsAt ?? 0;
            window.state.luckStacks = parsed.luckStacks ?? 0;
            window.state.bennyActive = parsed.bennyActive ?? false;
            window.state.bennyEndsAt = parsed.bennyEndsAt ?? 0;
            window.state.blessingActive = parsed.blessingActive ?? false;
            window.state.blessingEndsAt = parsed.blessingEndsAt ?? 0;
            window.state.purchasedItems = parsed.purchasedItems ?? [];
            window.state.bonusInventorySlots = parsed.bonusInventorySlots ?? 0;
            window.state.inventory = parsed.inventory ?? (window.state.inventory || {});
            window.state.fruits = parsed.fruits ?? (window.state.fruits || {});
            window.state.tears = parsed.tears ?? 0;
            window.state.potionInventory = parsed.potionInventory ?? [];
            window.state.btfPlusClaimed = parsed.btfPlusClaimed ?? false;
        }
    } catch (e) { console.warn('load failed', e) }
    updateUI();
    renderBrewableFruits();
}

// saveState() is now provided by index.js with hash integrity

const orderNumbers = [
    {code: '1000000', item: 'BTF Plus'}
]
// Update UI
function updateUI() {
    if(coinsEl){ coinsEl.textContent = window.state.coins; }
    if(tearsDisplayEl){ tearsDisplayEl.textContent = Math.floor(window.state.tears || 0); }
    
    // Update luck multiplier
    if(luckMultiplierEl){
        const { multiplier } = window.getLuckInfo ? window.getLuckInfo() : { multiplier: 1 };
        const displayMult = formatLuck(multiplier);
        luckMultiplierEl.textContent = `${displayMult}x`;
    }
    // Benny UI
    if(bennyTimerEl){
        const bActive = window.state.bennyActive && window.state.bennyEndsAt > Date.now();
        buyBennyBtn.disabled = window.state.coins < BENNY_COST || bActive;
        if(bActive){
            const remaining = Math.ceil((window.state.bennyEndsAt - Date.now())/1000);
            const minutes = Math.floor(remaining/60);
            const seconds = remaining%60;
            bennyTimerEl.textContent = `${minutes}:${seconds.toString().padStart(2,'0')} remaining`;
            bennyTimerEl.style.display = 'inline';
        } else {
            bennyTimerEl.style.display = 'none';
        }
    }
    // Blessing UI
    if(blessingTimerEl){
        const blActive = window.state.blessingActive && window.state.blessingEndsAt > Date.now();
        if(buyBlessingBtn) buyBlessingBtn.disabled = window.state.coins < BLESSING_COST || blActive;
        if(blActive){
            const remaining = Math.ceil((window.state.blessingEndsAt - Date.now())/1000);
            const minutes = Math.floor(remaining/60);
            const seconds = remaining%60;
            blessingTimerEl.textContent = `${minutes}:${seconds.toString().padStart(2,'0')} remaining`;
            blessingTimerEl.style.display = 'inline';
        } else {
            blessingTimerEl.style.display = 'none';
        }
    }
    
    // Calculate current potion cost based on purchases
    if (!window.state.luckPotionsPurchased) {
        window.state.luckPotionsPurchased = 0;
    }   
    const currentPotionCost = Math.floor(POTION_BASE_COST * Math.pow(1.5, window.state.luckPotionsPurchased));
    
    // Allow buying potions even when active (for stacking)
    buyBtn.disabled = window.state.coins < currentPotionCost;
    
    // Update button text to show current cost
    if (buyBtn) {
        const costText = currentPotionCost >= 1000000 
            ? `${(currentPotionCost / 1000000).toFixed(1)}M` 
            : currentPotionCost >= 1000 
            ? `${(currentPotionCost / 1000).toFixed(0)}k` 
            : currentPotionCost;
        buyBtn.textContent = `Buy (${costText}c)`;
    }
    
    if (window.state.potionActive) {
        const remaining = Math.ceil((window.state.potionEndsAt - Date.now()) / 1000);
        if (remaining <= 0) {
            window.state.potionActive = false;
            window.state.potionEndsAt = 0;
            window.state.luckStacks = 0;
            if(typeof window.saveState === 'function') window.saveState();
            timerEl.style.display = 'none';
            buyBtn.disabled = window.state.coins < currentPotionCost;
        } else {
            const minutes = Math.floor(remaining / 60);
            const seconds = remaining % 60;
            timerEl.textContent = `${minutes}:${seconds.toString().padStart(2, '0')} remaining`;
            timerEl.style.display = 'inline';
        }
    } else {
        timerEl.style.display = 'none';
    }
    
    // Slot Machine UI (one-time purchase)
    if(buySlotMachineBtn){
        const purchased = (window.state.bonusInventorySlots || 0) >= SLOT_MACHINE_BONUS;
        buySlotMachineBtn.disabled = (window.state.coins < SLOT_MACHINE_COST) || purchased;
        buySlotMachineBtn.textContent = purchased ? 'Purchased' : 'Buy Slot Machine';
    }
    if(slotsPurchasedEl){
        const base = 20;
        const totalSlots = base + (window.state.bonusInventorySlots || 0);
        const purchased = (window.state.bonusInventorySlots || 0) >= SLOT_MACHINE_BONUS;
        if(purchased){
            slotsPurchasedEl.textContent = `Current capacity: ${totalSlots} slots (Slot Machine owned)`;
        } else {
            slotsPurchasedEl.textContent = `Current capacity: ${base} slots (base)`;
        }
    }
}

// Brewing logic
const RARITY_POTENCY = {
    common: 1,
    rare: 2,
    epic: 4,
    special: 5,
    legendary: 6,
    spooky: 8,
    chromatic: 10,
    unique: 15,
    godly: 20
};
const RARITY_TEARS_COST = {
    common: 5,
    rare: 20,
    epic: 60,
    special: 80,
    legendary: 150,
    spooky: 200,
    chromatic: 300,
    unique: 1000,
    godly: 5000
};
const BREW_DURATION = 5 * 60 * 1000; // 5 minutes

function getFruitDef(fid){ return FRUITS.find(f=>f.id===fid); }

function renderBrewableFruits(){
    if(!brewFruitListEl) return;
    brewFruitListEl.innerHTML = '';
    const entries = Object.entries(window.state.fruits||{}).filter(([,cnt])=>cnt>0);
    if(entries.length===0){
        brewFruitListEl.innerHTML = '<div style="color:var(--muted)">No fruits available.</div>';
        return;
    }
    entries.forEach(([fid, cnt])=>{
        const def = getFruitDef(fid);
        const btn = document.createElement('button');
        btn.className = 'small';
        btn.textContent = `${def?def.name:fid} x${cnt}`;
        btn.addEventListener('click', ()=>toggleSelectedFruit(fid));
        brewFruitListEl.appendChild(btn);
    });
}

let selectedFruits = [];
function toggleSelectedFruit(fid){
    const idx = selectedFruits.indexOf(fid);
    if(idx>=0) selectedFruits.splice(idx,1); else if(selectedFruits.length<3) selectedFruits.push(fid);
    updateBrewPreview();
}

function updateBrewPreview(){
    if(!brewSelectionEl || !brewPreviewEl || !brewPotionBtn) return;
    if(selectedFruits.length===0){
        brewSelectionEl.textContent = 'No fruits selected.';
        brewPreviewEl.textContent = '';
        brewPotionBtn.disabled = true;
        return;
    }
    const names = selectedFruits.map(fid=>{ const d=getFruitDef(fid); return d?d.name:fid; }).join(', ');
    brewSelectionEl.textContent = `Selected: ${names}`;
    // potency is sum of individual potencies (capped at 100)
    let potency = 0; let cost = 0;
    selectedFruits.forEach(fid=>{
        const d = getFruitDef(fid);
        if(d){ potency += (RARITY_POTENCY[d.rarity]||0); cost += (RARITY_TEARS_COST[d.rarity]||0); }
    });
    potency = Math.min(potency, 100);
    brewPreviewEl.textContent = `Cost: ${cost} Tears`;
    const canAfford = (window.state.tears||0) >= cost;
    const haveAll = selectedFruits.every(fid => (window.state.fruits[fid]||0) > 0);
    brewPotionBtn.disabled = !(canAfford && haveAll);
    brewPotionBtn.onclick = ()=>brewPotion(potency, cost);
}

async function brewPotion(potency, cost){
    console.log('brewPotion called', {potency, cost, currentInventory: window.state.potionInventory});
    // consume fruits
    selectedFruits.forEach(fid=>{ if(window.state.fruits[fid]>0){ window.state.fruits[fid] -= 1; if(window.state.fruits[fid]===0) delete window.state.fruits[fid]; } });
    // consume tears
    window.state.tears = Math.max(0, (window.state.tears||0) - cost);
    
    // Determine potion name based on potency
    let potionName = 'Luck Potion';
    if (potency <= 3) {
        potionName = 'Buns Luck Potion';
    } else if (potency <= 8) {
        potionName = 'Weak Luck Potion';
    } else if (potency <= 15) {
        potionName = 'Basic Luck Potion';
    } else if (potency <= 25) {
        potionName = 'Better Luck Potion';
    } else if (potency <= 40) {
        potionName = 'Superior Luck Potion';
    } else if (potency <= 60) {
        potionName = 'Mega Superior Luck Potion';
    } else if (potency <= 80) {
        potionName = 'Mega Mega Superior Luck Potion';
    } else {
        potionName = 'Godly Luck Potion';
    }
    
    // add potion to inventory
    if(!Array.isArray(window.state.potionInventory)) window.state.potionInventory = [];
    window.state.potionInventory.push({ type:'luck', name: potionName, potency, durationMs: BREW_DURATION, createdAt: Date.now() });
    console.log('After push', {newInventory: window.state.potionInventory, stateKeys: Object.keys(window.state)});
    // reset selection
    selectedFruits = [];
    if(typeof window.saveState === 'function') window.saveState();
    console.log('After saveState');
    updateUI();
    renderBrewableFruits();
    if(typeof showAlert === 'function'){
        await showAlert(`${potionName} brewed successfully! Check your Inventory to use it.`);
    } else {
        alert(`${potionName} brewed! Check your Inventory to use it.`);
    }
}



// Buy potion (stackable - extends duration)
buyBtn.addEventListener('click', () => {
    // Initialize purchase counter if it doesn't exist
    if (!window.state.luckPotionsPurchased) {
        window.state.luckPotionsPurchased = 0;
    }
    
    // Calculate exponential cost: baseCost * (1.5 ^ purchases)
    const currentCost = Math.floor(POTION_BASE_COST * Math.pow(1.5, window.state.luckPotionsPurchased));
    
    if (window.state.coins >= currentCost) {
        window.state.coins -= currentCost;
        window.state.luckPotionsPurchased += 1;
        
        if (window.state.potionActive && window.state.potionEndsAt > Date.now()) {
            // Already active: increment stacks (max 49 to cap multiplier at 100x), reset timer
            window.state.luckStacks = Math.min(window.state.luckStacks + 1, 49);
            window.state.potionEndsAt = Date.now() + POTION_DURATION;
        } else {
            // Not active or expired: start new effect
            window.state.potionActive = true;
            window.state.luckStacks = 1;
            window.state.potionEndsAt = Date.now() + POTION_DURATION;
        }
        // Add to purchased items if not already there
        if (!window.state.purchasedItems.some(item => item.name === 'Potion of Luck')) {
            window.state.purchasedItems.push({
                name: 'Potion of Luck',
                icon: '',
                    description: 'Makes all items about 2x more common for 5 minutes'
            });
        }
        if(typeof window.saveState === 'function') window.saveState();
        updateUI();
    }
});

// Buy Benny Boost
if(buyBennyBtn){
    buyBennyBtn.addEventListener('click', ()=>{
        if(window.state.coins >= BENNY_COST && !window.state.bennyActive){
            window.state.coins -= BENNY_COST;
            window.state.bennyActive = true;
            window.state.bennyEndsAt = Date.now() + BENNY_DURATION;
            if(!window.state.purchasedItems.some(i=>i.name==='Benny Boost')){
                window.state.purchasedItems.push({ name: 'Happy Powder', icon: '😃', description: '+10% CPS for 5 minutes' });
            }
            if(typeof window.saveState === 'function') window.saveState();
            updateUI();
        }
    });
}

// Buy Blessing of the Pumpkin
if(buyBlessingBtn){
    buyBlessingBtn.addEventListener('click', ()=>{
        if(window.state.coins >= BLESSING_COST && !window.state.blessingActive){
            window.state.coins -= BLESSING_COST;
            window.state.blessingActive = true;
            window.state.blessingEndsAt = Date.now() + BLESSING_DURATION;
            if(!window.state.purchasedItems.some(i=>i.name==='Blessing of the Pumpkin')){
                window.state.purchasedItems.push({ name: 'Blessing of the Pumpkin', icon: '🎃', description: 'Makes spooky items 2/3 as rare for 5 minutes' });
            }
            if(typeof window.saveState === 'function') window.saveState();
            updateUI();
        }
    });
}

// Buy Slot Machine
if(buySlotMachineBtn){
    buySlotMachineBtn.addEventListener('click', ()=>{
        const alreadyBought = (window.state.bonusInventorySlots || 0) >= SLOT_MACHINE_BONUS;
        if(alreadyBought){
            if(typeof showAlert === 'function'){
                showAlert('You already own the Slot Machine.');
            } else {
                alert('You already own the Slot Machine.');
            }
            return;
        }
        if(window.state.coins >= SLOT_MACHINE_COST){
            window.state.coins -= SLOT_MACHINE_COST;
            window.state.bonusInventorySlots = SLOT_MACHINE_BONUS; // one-time purchase
            if(!window.state.purchasedItems.some(i=>i.name==='Slot Machine')){
                window.state.purchasedItems.push({ name: 'Slot Machine', icon: '🎰', description: `Adds +5 pet inventory slots permanently` });
            }
            if(typeof window.saveState === 'function') window.saveState();
            updateUI();
            if(typeof showAlert === 'function'){
                showAlert(`Purchased! Your pet inventory capacity is now ${20 + window.state.bonusInventorySlots} slots.`);
            } else {
                alert(`Purchased! Your pet inventory capacity is now ${20 + window.state.bonusInventorySlots} slots.`);
            }
        }
    });
}


if(buyThanksgivingPotion){
    buyThanksgivingPotion.addEventListener('click', ()=>{
        if(window.state.coins >= THANKSGIVING_POTION_COST && !window.state.thanksgivingPotionActive){
            window.state.coins -= THANKSGIVING_POTION_COST;
            window.state.thanksgivingPotionActive = true;
            window.state.thanksgivingPotionEndsAt = Date.now() + THANKSGIVING_POTION_DURATION;
            if(!window.state.purchasedItems.some(i=>i.name==='Potion of Thanksgiving')){
                window.state.purchasedItems.push({ name: 'Potion of Thanksgiving', icon: '🦃', description: 'All shop items 50% off for 5 minutes' });
            }
            if(typeof window.saveState === 'function') window.saveState();
            updateUI();
        }
    });
} 

// Gift Code redemption handler
const giftCodeInput = document.getElementById('giftCodeInput');
const redeemGiftCodeBtn = document.getElementById('redeemGiftCode');

if(redeemGiftCodeBtn && giftCodeInput){
    redeemGiftCodeBtn.addEventListener('click', async ()=>{
        const code = giftCodeInput.value.trim().toUpperCase();
        
        if(!code){
            if(typeof showAlert === 'function'){
                await showAlert('Please enter a gift code.');
            } else {
                alert('Please enter a gift code.');
            }
            return;
        }
        
        // Call redemption logic from index.js if available
        if(typeof redeemGiftCode === 'function'){
            const result = redeemGiftCode(code);
            
            if(result.success){
                // Refresh state from localStorage to get updated values
                loadState();
                updateUI();
                if(typeof showAlert === 'function'){
                    await showAlert('✅ ' + result.message);
                } else {
                    alert('✅ ' + result.message);
                }
                giftCodeInput.value = ''; // Clear input
            } else {
                if(typeof showAlert === 'function'){
                    await showAlert('❌ ' + result.message);
                } else {
                    alert('❌ ' + result.message);
                }
            }
        } else {
            if(typeof showAlert === 'function'){
                await showAlert('Gift code system not available. Please ensure you are on the correct page.');
            } else {
                alert('Gift code system not available. Please ensure you are on the correct page.');
            }
        }
    });
    
    // Allow Enter key to redeem
    giftCodeInput.addEventListener('keypress', (e)=>{
        if(e.key === 'Enter'){
            redeemGiftCodeBtn.click();
        }
    });


}

    if(claimBTFPlusBtn){
        claimBTFPlusBtn.addEventListener('click', ()=>{
            claimPopUp.style.display = 'flex'; 
        });
    }

    if(closeClaimPopUpBtn){
        closeClaimPopUpBtn.addEventListener('click', ()=>{
            claimPopUp.style.display = 'none'; 
        });
    }

    if(claimOrderBtn){
        claimOrderBtn.addEventListener('click', async ()=>{
            const enteredCode = orderNumberInput.value.trim();
            const order = orderNumbers.find(o => o.code === enteredCode);
            if(order){
                if(order.item === 'BTF Plus'){
                    if (window.state.btfPlusClaimed) {
                        if(typeof showAlert === 'function'){
                            await showAlert('You already have BTF+.');
                        } else {
                            alert('You already have BTF+.');
                        }
                    } else {
                        window.state.btfPlusClaimed = true;
                        if(typeof window.saveState === 'function'){
                            window.saveState();
                        }
                        if(typeof showAlert === 'function'){
                            await showAlert('BTF+ claimed successfully! Enjoy your perks.');
                            console.log('BTF+ claimed successfully');
                        } else {
                            alert('BTF+ claimed successfully! Enjoy your perks.');
                            console.log('BTF+ claimed successfully');
                            
                        }
                        claimPopUp.style.display = 'none';
                    }
                }
            } else {
                if(typeof showAlert === 'function'){
                    await showAlert('Invalid order number.');
                } else {
                    alert('Invalid order number.');
                }
            }
        });
    }

// Check timer every second
setInterval(updateUI, 1000);

// Initial load
loadState();
renderBrewableFruits();
updateBrewPreview();

}); // End DOMContentLoaded
} // End shop page guard